export enum BuilderAgentTools {
  SetMapCenterAndZoom = 'set_map_center_and_zoom',
  SetMapCenterAndZoomToLayer = 'set_map_center_and_zoom_to_layer',
  GetFormulaWidget = 'get_formula_widget',
  GetCategoryWidget = 'get_category_widget',
  GetHistogramWidget = 'get_histogram_widget',
  GetTimeSeriesWidget = 'get_time_series_widget',
  FilterCategoryWidget = 'filter_category_widget',
  FilterHistogramWidget = 'filter_histogram_widget',
  FilterRangeWidget = 'filter_range_widget',
  SetLayersVisibility = 'set_layers_visibility',
  GetMapCoordinates = 'get_map_coordinates',
  GetSpatialFilter = 'get_spatial_filter',
  GetActiveFilters = 'get_active_filters',
  SetSpatialFilter = 'set_spatial_filter',
  SetSqlParameterText = 'set_sql_parameter_text',
  SetSqlParameterDateRange = 'set_sql_parameter_date_range',
  SetSqlParameterNumeric = 'set_sql_parameter_numeric',
  SetSqlParameterNumericRange = 'set_sql_parameter_numeric_range',
  GetControlTextValues = 'get_control_text_values',
  GetControlDateBounds = 'get_control_date_bounds',
  GetControlNumericBounds = 'get_control_numeric_bounds',
  SetControlText = 'set_control_text',
  SetControlDateRange = 'set_control_date_range',
  SetControlNumeric = 'set_control_numeric',
  SetControlNumericRange = 'set_control_numeric_range',
  AddSource = 'add_source',
  RemoveSource = 'remove_source',
  AddLayer = 'add_layer',
  RemoveLayer = 'remove_layer',
  SetLayerStyle = 'set_layer_style',
  AddMarker = 'add_marker',
  AsyncWorkflowJobCheckResults = 'async_workflow_job_check_results',
  AddSourceFromWorkflows = 'add_source_from_workflows',
  RefreshDataSources = 'refresh_data_sources'
}

export enum BuilderAgentAssistantTools {
  UpdateAgentConfiguration = 'update_agent_configuration'
}
